/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React from 'react';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';
import type { TextFieldTypes } from 'types';
import makeStyles from '@mui/styles/makeStyles';
import InputField from '../inputs/InputField';

const useStyles = makeStyles(() => ({
  shrink: {
    '& label': {
      transform: 'translate(12px, 10px) scale(0.75) !important',
    },
  },
}));

export default function HookTextField(props: TextFieldTypes): JSX.Element {
  const {
    disabled, control, maxLength, minLength, placeholder, label, name, errors, type, rows, multiline, endAdornment, startAdornment, className, autoFocus, notPreventDefault,
  } = props;

  const classes = useStyles();
  return (
    <Controller
      control={control}
      name={name !== undefined ? name : ''}
      render={({ field }): JSX.Element => (
        <InputField
          className={`${className} ${type === 'number' && classes.shrink} mb-24`}
          label={label}
          name={name}
          type={type}
          rows={rows}
          placeholder={placeholder}
          inputProps={{
            maxLength: maxLength !== undefined ? maxLength : 524288,
            minLength: minLength !== undefined ? minLength : 0,
          }}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
            if (notPreventDefault !== true) {
              if (e.key === 'Enter' && multiline !== true) {
                e.preventDefault();
              }
            }
          }}
          error={Boolean(get(errors, name !== undefined ? name : ''))}
          helperText={get(errors, name !== undefined ? name : '')?.message}
          onChange={field.onChange}
          value={field.value ?? ''}
          InputLabelProps={{ shrink: type === 'date' ? true : undefined }}
          multiline={multiline}
          endAdornment={endAdornment}
          disabled={disabled}
          startAdornment={startAdornment}
          autoFocus={autoFocus}
        />
      )}
    />
  );
}
